import { Base } from './_base';
import { merge_by_template } from '@shared/helpers/collections';

export class CallFrontend extends Base {
  constructor(item) {
    super(item);

    this.data = merge_by_template(this.data, {
      params: {
        contact_method: null,
        timeout: null
      },
      options: {
        next: null,
        timeout: null
      }
    });
  }
}
